<template>
  <div class="perguntas" style="text-align: left">
    <form
      id="contact-form"
      class="col-sm-12 scrollimation fade-right"
      v-on:submit.prevent="enviaPergunta"
    >
      <div class="section-header scrollimation fade-up in">
        <h1 class="section-title">Pesquisa de Sastifação</h1>

        <p class="section-description lead">
          Olá {{ pessoa.NOME }},<br />
          Com o intuíto de melhor atendê-lo e que possamos, sempre, melhorar
          nossos serviços, gostariamos de ouvir a sua opinião.<br />
        </p>
      </div>

      <h3 class="primary">1. Avalie nossos serviços:</h3>
      <div style="margin-left: 3%">
        <div v-for="(value, key) in perguntas" :key="key">
          <div v-if="value.TIPO === 'NOTA'">
            <h4 class="primary">
              {{ value.DS_PERGUNTA }}
              <em v-if="value.CD_CODIGO === 'D1'">{{ pessoa.COLETA }} </em>
              <em v-if="value.CD_CODIGO === 'F1'">{{ pessoa.MEDICO }} </em>
              <em v-if="value.CD_CODIGO === 'A1'">{{ pessoa.MEDICO }} </em
              ><em v-if="value.CD_CODIGO === 'C1'">{{ pessoa.RECEPCAO }} </em>
            </h4>
            <div class="controls">
              <div class="form-control">
                <star-rating
                  @rating-selected="setValue($event, value.CD_CODIGO)"
                  v-bind:increment="1"
                  v-bind:max-rating="value.CD_CODIGO === 'Q1' ? 10 : 5"
                  inactive-color="#000"
                  active-color="#21B799"
                  v-bind:star-size="value.CD_CODIGO === 'Q1' ? 25 : 50"
                >
                </star-rating>
              </div>
            </div>
          </div>

          <div v-if="value.TIPO === 'DESCRICAO'">
            <hr />
            <div class="form-group">
              <label class="control-label" for="contact-message">Message</label>
              <h4 class="primary">{{ value.DS_PERGUNTA }}</h4>
              <div class="controls">
                <textarea
                  id="E1"
                  placeholder="Digite aqui..."
                  class="form-control input-lg"
                  rows="3"
                  style="color: black"
                ></textarea>
              </div>
            </div>
            <!-- End textarea -->
          </div>
        </div>
      </div>
      <br /><br /><br />
      <p>
        <input
          type="submit"
          class="btn btn-theme btn-block"
          value="ENVIAR FORMULÁRIO!"
          v-show="bt_envia"
        />
      </p>
      <input type="hidden" name="submitted" id="submitted" value="true" />
    </form>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  components: {
    StarRating,
  },
  name: "Perguntas",
  data() {
    return {
      msg: "",
      mostarPerg: true,
      bt_envia: true,
      atendimento: this.$route.params.atendimento,
      perguntas: [],
      respostas: {},
      pessoa: [],
      cont: 0,
    };
  },
  mounted() {

    var x = this;

    $.ajax({
      method: "get",
      url: `${this.$api}/carregaPessoaAtendimento/${this.atendimento}`,
      dataType: "json",
      beforeSend: function () {
        console.log("carregando...");
      },
      success: function (response) {
        if (response.length > 0) {
          x.pessoa = response[0];
        } else {
          x.$router.push("/");
        }
      },
    });

    $.ajax({
      method: "get",
      url: `${this.$api}/carregaPerguntas/${this.atendimento}`,
      dataType: "json",
      beforeSend: function () {
        console.log("carregando...");
      },
      success: function (response) {
        x.perguntas = response;
      },
    });
  },
  methods: {
    setValue: function (val, cd) {
      if (this.respostas[cd] == undefined && cd != "E1") {
        this.cont++;
      }
      this.$set(this.respostas, cd, val); //  3559606
    },
    enviaPergunta: function () {
      var x = this;
      var seenvia = false;
      var opn = $("#E1").val();

      if (opn.length > 0) {
        this.setValue(opn, "E1");
      }

      if (this.cont >= this.perguntas.length - 1) {
        $.ajax({
          method: "post",
          url: `${this.$api}/enviarPesquisa`,
          data: { pessoa: this.pessoa, res: this.respostas },
          dataType: "json",
          beforeSend: function () {
            console.log("carregando...");
          },
          success: function (response) {
            console.log(response);
            x.bt_envia = false;
            alert("Formulário enviado!");
            location.href = "http://www.samel.com.br/";
          },
        });
      } else {
        alert("Por favor, avalie antes as perguntas.");
      }

      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Perguntas.vue